export default "__VITE_ASSET__nx4KNwLu1yFUuwJzZBrYHw__";